import { render, staticRenderFns } from "./SelectAltSupplierDialog.vue?vue&type=template&id=129bc0d4"
import script from "./SelectAltSupplierDialog.vue?vue&type=script&lang=js"
export * from "./SelectAltSupplierDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports